import { Media } from '#types/generated/graphql-types';

const hasEventDates = (media: Media) => {
  return !!media?.details?.startDate && !!media?.details?.endDate;
};

export default hasEventDates;
